<template>
	<div class="doc_home_page">
		<div class="top_new">
			<div class="top_layout">
				<div class="top_title">
					接入指南
				</div>
				<div class="top_content">
					<div class="new_item">
						<router-link to="apiaccess" class="item_link">
							<i class="icon-zuidahuihua"></i>
							<p>接入流程</p>
						</router-link>
					</div>
					<div class="new_item">
						<router-link to="Authorization" class="item_link">
							<i class="icon-jianyi"></i>
							<p>鉴权方案</p>
						</router-link>	
					</div>
				</div>
			</div>
		</div>
		<div class="bottom_links">
			<div class="bottom_layout">
				<h2 class="bottom_title">
					接口文档
				</h2>
				<div class="bottom_content">
					<div class="bottom_group_row">
						<div class="bottom_group">
							<i class="icon-ARsaomiao"></i>
							<p>物体识别</p>
							<b></b>
							<ul>
								<li class="link_list">
									<router-link to="/skobj-api-userhelp">
										<span>SKObjects-API</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skeye-ios-userhelp">
										<span>SKEye-iOS</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skeye-android-userhelp">
										<span>SKEye-Android</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skeye-linux-userhelp">
										<span>SKEye-Linux</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skeye-win-userhelp">
										<span>SKEye-Windows</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skeye-unity-userhelp">
										<span>SKEye-Unity</span>
									</router-link>
								</li>
							</ul>
						</div>
						<div class="bottom_group">
							<i class="icon-renlianshibie"></i>
							<p>人脸识别</p>
					
							<ul>
								<li class="link_list">
									<router-link to="/skface-ios-userhelp">
										<span>SKFace-iOS</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skface-android-userhelp">
										<span>SKFace-Android</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skface-live-android-userhelp">
										<span>SKFaceLive-Android</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skface-lite-android-userhelp">
										<span>SKFaceLite-Android</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skface-family-android-userhelp">
										<span>SKFaceFam-Android</span>
									</router-link>
								</li>							
								<li class="link_list">
									<router-link to="/skface-win-userhelp">
										<span>SKFace-Windows</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/skface-live-win-userhelp">
										<span>SKFaceLive-Windows</span>
									</router-link>
								</li>
							
							</ul>
						</div>
						<div class="bottom_group">
							<i class="icon-renyuanguanli"></i>
							<p>人脸识别管理系统</p>
							<!--<li class="link_list">
									<span>API文档 - V2</span>
								</li>-->
							<!--<b>仅面向盛开开发者（尚未开放）</b>-->
							<ul>		
								<li class="link_list">
									<router-link to="/skfrm-userhelp">
										<span>FRM API-v2</span>
									</router-link>
								</li>
								<!--<li class="link_list">
									<router-link to="/sk-frm-LoginAuthenticationCode">
										<span>账号登录</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/sk-frm-GettingAccountInformation">
										<span>账号设置</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/sk-frm-NewSubaccount">
										<span>子账号管理</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/sk-frm-Newproject">
										<span>项目管理</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/sk-frm-Newstaff">
										<span>人员管理</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/sk-frm-GettingTerminalInformation">
										<span>终端管理</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/sk-frm-Facedetection">
										<span>人脸识别</span>
									</router-link>
								</li>
								<li class="link_list">
									<router-link to="/sk-frm-identificationrecords">
										<span>统计信息</span>
									</router-link>
								</li>-->
							
							</ul>
						</div>
					</div>					
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{

			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../less/index.less';
	.doc_home_page{
		width: 100%;
		padding-top:78px;
		.top_new{
			background-color: #fff;
			padding-bottom: 68px;
			text-align: center;
			.top_layout{
				width: 1200px;
    			margin: 0 auto;
    			color:#333;
			}
			.top_title{
				font-size: 30px;
			    text-align: center;
			    font-weight: 500;
			    color:#4f4f4f;
			    padding:56px 0 50px 0;
			}
			.top_content{
				.new_item{
					width: 595px;
					height: 140px;
					box-sizing: border-box;
				    background-color: #fff;
				    display: inline-block;
				    //float: left;
				    vertical-align: top;
				    transition: all .3s ease;
				    .item_link{
				    	display: block;
				    	height: 140px;
				    	width: 160px;
				    	margin:0 auto;
				    }
				    i{
				    	font-size: 76px;
				    	color:@primary-blue;
				    }
				    p{
				    	font-size: 20px;
    					margin-top: 15px;
    					font-weight: 600;
    					color:#4f4f4f;
				    }
				    .item_link:hover{
				    	color:@primary-color;
				    	i{color:@primary-color;}
				    }
				}	
			}
		}
		.bottom_links{
			background: #F8F8F8;
			padding-bottom:60px;
			.bottom_layout{
				width: 1200px;
				margin: 0 auto;
				.bottom_title{
					font-size: 30px;
				    text-align: center;
				    padding: 56px 0;
				    font-weight: 500;
				    color:#4f4f4f;
				}
				.bottom_content{
					.bottom_group_row{
						overflow: hidden;
						//text-align: left;
						.bottom_group{
							float: left;
							color:@primary-blue;
							width: 400px;
							i{
								font-size:66px;
							}
							p{
								text-align: left;
								width:210px;
								font-size: 20px;
								margin-top:10px;
								font-weight: 600;
								color:#333;
								margin-left:160px;
							}
							b{
								display: block;
								font-weight:400;
								text-align: left;
								width:210px;
								font-size: 12px;
								margin-top:5px;
								font-weight: 600;
								color:#c1c1c1;
								margin-left:160px;
								height:18px;
								line-height:18px;
							}
							ul{
								width:210px;
								margin-top: 30px;
								text-align: left;
								margin-left:160px;

								.link_list{
									a{
										font-size:16px;
										margin-bottom:25px;
									}
									font-size:16px;
									margin-bottom:25px;
									span{
										display: inline-block;
										padding-bottom:10px;
										border-bottom:1px solid #bfbfbf;
										cursor:pointer;
										font-family:Arial,Helvetica,sans-serif;
									}
									span:hover{
										color:@primary-color;
										font-weight: 600;
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/documents/docHomePage.vue